﻿cb.define([], function () {
	var ST_st_exchangeinfo_VM_Extend = {
		doAction: function (name, viewmodel) {
			if (this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {
			let gridModel = viewmodel.getGridModel();
			gridModel.on('afterSetDataSource', () => {
				const rows = gridModel.getRows();
				const actions = gridModel.getCache('actions');
				const actionsStates = [];
				rows.forEach(data => {
					const actionState = {};
					actions.forEach(action => {
						if (action.cItemName == "btnExchange") {
							//处理失败重复
							if (data.status == "1") {
								actionState[action.cItemName] = { visible: true };
							}
							else {
								actionState[action.cItemName] = { visible: false };
							}
						} else if (action.cItemName == "btnDelete") {
							actionState[action.cItemName] = { visible: false };
						} else if (action.cItemName == "btnDownExchange") {
							//处理中不下载
							if (data.status != "0") {
								actionState[action.cItemName] = { visible: true };
							}
							else {
								actionState[action.cItemName] = { visible: false };
							}
						}else if (action.cItemName == "btnDownError") {

							if (data.status == "1") {
								actionState[action.cItemName] = { visible: true };
							}
							else {
								actionState[action.cItemName] = { visible: false };
							}
						}
					});
					actionsStates.push(actionState);
				});
				gridModel.setActionsState(actionsStates);
			});

			gridModel.on('dblClick', function (args) {
				var params = {
					mode: 'edit',
					readOnly: true,
					id: args.vouchID
				};
				var data = {
					billtype: 'voucher',
					billno: args.billnum,
					params: params
				};
        cb.loader.runCommandLine('bill', data, viewmodel);
        return false;
			});

			//批量重发
			viewmodel.on('batchexchange', function (args) {
				//var selectedRows = viewmodel.getGridModel().getRow(args.params.index);
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if (selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择交换项！', 'warning');
					return false;
				}
				for(var i=0;i<selectedRows.length;i++){
					selectedRows[i].failedInfo=null;
				}
				var proxy = cb.rest.DynamicProxy.create({ ensure: { url: args.cSvcUrl, method: args.cHttpMethod } });
				var params = {
					billnum: "st_exchangeinfo",
					data: JSON.stringify(selectedRows)
				}
				proxy.ensure(params, function (err, res) {
					if (err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					const actionText = '重发';
					if (selectedRows.length === 1) {
						if (res.failCount) {
							cb.utils.alert(`${actionText}失败：${res.messages[0]}`, 'error');
						} else {
							cb.utils.alert(`${actionText}成功`, 'success');
						}
					} else {
						if (res.failCount > 0) {
							cb.utils.alert(`${actionText}完成,共${res.count}条, 成功${res.sucessCount}条,失败${res.failCount}条,失败原因:${res.messages}`);
						}
						else {
							cb.utils.alert(`${actionText}完成,共${res.count}条, 成功${res.sucessCount}条,失败${res.failCount}条`);
						}
					}
					viewmodel.execute('refresh');
				});
			});

			//重发
			viewmodel.on('exchange', function (args) {
				var selectedRows = viewmodel.getGridModel().getRow(args.params.index);
				//var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if (selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择交换项！', 'warning');
					return false;
				}
				selectedRows['failedInfo']=null;
				var proxy = cb.rest.DynamicProxy.create({ ensure: { url: args.cSvcUrl, method: args.cHttpMethod } });
				var params = {
					billnum: "st_exchangeinfo",
					data: JSON.stringify(selectedRows)
				}
				proxy.ensure(params, function (err, result) {
					if (err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
				});
			});

			//取交换信息
			viewmodel.on('downexchange', function (args) {
				var selectedRows = viewmodel.getGridModel().getRow(args.params.index);
				if (selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择交换项！', 'warning');
					return false;
				}
				selectedRows["action"] = "downexchange";
				selectedRows['failedInfo']=null;
				var proxy = cb.rest.DynamicProxy.create({ ensure: { url: args.cSvcUrl, method: args.cHttpMethod } });
				var params = {
					billnum: "st_exchangeinfo",
					data: JSON.stringify(selectedRows)
				}
				proxy.ensure(params, function (err, result) {
					if (err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					//prompt("交换信息", result);
					viewmodel.communication({
					  type: 'modal',
					  payload: {
						mode: 'html',
						html: '<textarea style="width:100%;height:250px;">'+result+'</textarea>'
					  }
					});
				});
			});

			//取交换错误信息
			viewmodel.on('downerror', function (args) {
				var selectedRows = viewmodel.getGridModel().getRow(args.params.index);
				if (selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择交换项！', 'warning');
					return false;
				}
				viewmodel.communication({
					  type: 'modal',
					  payload: {
						mode: 'html',
						html: '<textarea style="width:100%;height:250px;">'+selectedRows.failedInfo+'</textarea>'
					  }
					});
			 });
		}
	}

	try {
		module.exports = ST_st_exchangeinfo_VM_Extend;
	} catch (error) {

	}
	return ST_st_exchangeinfo_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_exchangeinfo_VM.Extend.js